<div class="container">
  <mat-tab-group
    [selectedIndex]="selected.value"
    (selectedTabChange)="back($event)"
  >
    <mat-tab label="Inspecciones">
      <div style="margin-top: 20px">
        <data-table
          title="Inspecciones"
          [columns]="columnasPreo"
          [configuration]="configurationPreo"
          [reloadTable]="recargarTablaPreo"
          (view)="viewDetail($event)"
          (delete)="eliminarPreo($event)"
          (add)="addPre($event)"
          [params]="paramsPreoperacional"
          [url]="urlGetTablaHistoricoPreo"
          [headerFilters]="headerFilters"
          [headerFileXlsm]="headerFileTableXlsm"
          [xslxParams]="xslxParams"
          [xslxTitleFields]="['code','formattedDate']"
          [xslxSheetNameFields]="['code','formattedDate']"
          xslxBodyFields="questions"
          [roleId]="roleId"
          [moduleId]="7"
          [subModuleId]="29"
        >
        </data-table>
      </div>
    </mat-tab>

    <mat-tab label="Inspeccion Detalle" *ngIf="selected.value == 1">
      <div style="margin-top: 20px">
        <div class="d-flex flex-column align-items-center mt-2">
          <app-button-label [labelsEdit]="labels">
          </app-button-label>

          <div style="width: 100%">
            <data-table
              [title]="title"
              [columns]="columnasPreoDetalle"
              [data]="dataPreoDetalle"
              [configuration]="configurationPreoDetalle"
              [reloadTable]="recargarTablaPreoDetalle"
              [headerFileXlsm]="headerFileXlsm"
              (fileIconClick)="onFileIconClick($event)"
            >
            </data-table>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
